export default __webpack_public_path__ + "static/media/custom-dimensions.ed85abba.png";